// Single source of truth for the canonical site URL used in meta tags.
// Set via REACT_APP_SITE_URL at build time; defaults to the production domain.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://bc-security.ca"
).replace(/\/$/, "");

export const canonicalFor = (pathname = "/") => {
  const p = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return p === "/" ? `${SITE_URL}/` : `${SITE_URL}${p}`;
};
